<template>
  <div v-loading.fullscreen.lock="loading" class="consult_list">
    <!-- 头部 -->
    <top-part :rightPart="true">
      <template slot="difinePort">
        <van-dropdown-menu active-color="#29BEBC" :overlay="false">
          <van-dropdown-item
            v-model="currentType"
            :options="typeList"
            @change="onFilter()"
          />
        </van-dropdown-menu>
      </template>
    </top-part>
    <!-- 头部 结束 -->
    <div
      class="data_list ctn_top"
      v-infinite-scroll="loadMore"
      infinite-scroll-immediate-check="false"
      infinite-scroll-distance="50"
    >
      <div
        v-for="(item, index) in dataList"
        :key="index"
        @click="toDetail(item)"
      >
        <div>
          <span :class="index % 2 == 0 ? 'type_btn_1' : 'type_btn_2'">{{
            item.newsTypeName
          }}</span>
          <span class="consult_title">{{ item.newsTitle }}</span>
        </div>
        <div class="my_flex">
          <div class="container_ctn">
            <!-- <div class="consult_ctn" v-html="item.newsRemarksAll"></div> -->
            <div class="consult_ctns">{{ item.directions }}</div>
            <div class="my_flex botton_text">
              <div v-if="item.isRead == 'false'" class="read_new">最新</div>
              <div v-else>
                <img src="@/images/eye.png" alt />
                <span>{{ item.readCounts }}</span>
              </div>
              <div>{{ transfromMoment(item.sendTime) }}</div>
            </div>
          </div>
          <img :src="item.fileUrl" alt />
        </div>
      </div>
    </div>
    <p class="nomore" v-if="noMore">
      ———&nbsp;&nbsp;&nbsp;&nbsp;没有更多了&nbsp;&nbsp;&nbsp;&nbsp;———
    </p>

    <!-- 没数据时 -->
    <div class="blank" v-if="!dataList.length">
      <img src="@/images/404-02.png" alt />
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
import { addNewsPointBeforeRedirect } from "@/common/api";

import moment from "moment";
export default {
  components: {
    topPart,
  },
  data() {
    return {
      loading: true,
      dataList: [], //兑换列表
      currentPage: 1,
      noMore: false, //是否展示更多
      typeList: [], //咨询分类
      currentType: "",
    };
  },
  mounted() {
    const { newsTypeName, welfareTypeId } = this.$route.query;
    document.title = newsTypeName || "淘文化";
    this.currentType = welfareTypeId || "";
    this.gianNewListType();
    console.log(1);
    this.queryFn();
  },
  methods: {
    onFilter() {
      this.currentPage = 1;
      this.dataList = [];
      this.queryFn();
    },
    transfromMoment(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD");
      }
      return "";
    },
    loadMore() {
      console.log(22222222);
      if (!this.noMore) {
        this.currentPage++;

        this.queryFn();
      }
    },
    queryFn() {
      let params = {
        currentPage: this.currentPage,
        pageSize: 10,
        newsTypeId: this.currentType,
        clientType: 1,
      };
      this.centralControl.axios.centralControl(
        "getNewsList",
        (res) => {
          const { code, message, data } = res;
          this.loading = false;
          if (code == 200) {
            // this.dataList = data;
            const { list, total } = data;
            this.dataList = [...this.dataList, ...list];
            if (this.dataList.length > 0 && list.length == 0) {
              this.noMore = true;
              return;
            }
          } else {
            toast(this, message, "error");
          }
        },
        params
      );
    },
    toDetail(item) {
      if (item.redirectUrl) {
        addNewsPointBeforeRedirect({ id: item.id }).then((res) => {
          const { code, message, data } = res;
          if (code == 200) {
            location.href = item.redirectUrl;
          } else {
            toast(this, message, "error");
          }
        });
      } else {
        this.$router.push({
          path: "consultDetail",
          query: {
            consultDetailId: item.id,
          },
        });
      }
    },
    // 获取资讯分类列表
    gianNewListType() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getNewsTypeAPP",
        (res) => {
          const { code, data, message } = res;
          if (code == 200) {
            data &&
              data.length &&
              data.forEach((item) => {
                item.value = item.id;
                item.text = item.name;
              });
            let arr = [
              {
                text: "淘文化",
                value: "",
              },
            ];
            this.typeList = [...arr, ...data];
          } else {
            toast(this, message, "error");
          }
        },
        {}
      );
    },
  },
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common';

.consult_list {
  .top-box {
    justify-content: space-between;
  }

  .van-tab--active {
    color: #38C6C3;
  }

  .van-dropdown-menu__bar {
    box-shadow: none;
  }

  .van-sticky {
    position: fixed;
    width: 100%;
    top: 45px;
    left: 0;
    z-index: 1;
  }

  .van-dropdown-item__option {
    text-align: center;
  }

  .van-cell__value {
    display: none;
  }

  .van-dropdown-menu__bar {
    height: 44px;
  }

  .top-box .van-dropdown-menu {
    flex: 0.5;
    margin-right: 20px;
  }

  .van-ellipsis {
    width: 200px;
    text-align: right;
  }

  .consult_ctn {
    img, br {
      display: none;
    }

    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 13px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(136, 136, 136, 1);
    line-height: 18px;

    p, span, ol, li, ul, h1, h2, strong, em, h3, a, pre {
      display: inline;
      color: rgba(136, 136, 136, 1) !important;
      background: none !important;
    }
  }

  .data_list {
    background: #FFF;

    .read_new {
      font-size: 11px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #FF4B4B;
      line-height: 16px;
    }

    >div {
      padding: 8px 16px;
      border-bottom: 1px solid #EFEFF4;

      .type_btn_1 {
        padding: 1px 6px;
        height: 18px;
        border-radius: 9px;
        font-size: 11px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #29BEBC;
        line-height: 18px;
        margin-right: 8px;
        border: 1px solid #29BEBC;
      }

      .type_btn_2 {
        padding: 2px 6px;
        height: 18px;
        background: linear-gradient(180deg, #FF7C8B 0%, #FF3B53 100%);
        border-radius: 9px;
        font-size: 11px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 18px;
        margin-right: 8px;
      }

      .consult_title {
        // ellipsis();
        // width: 100%;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(53, 53, 53, 1);
        line-height: 24px;
        margin-bottom: 6px;
      }

      .my_flex {
        display: flex;
        justify-content: space-between;
        align-items: center;

        >img {
          // min-width: 70px;
          // min-height: 50px;
          // max-width: 72px;
          // max-height: 70px;
          width: 72px;
          height: 65px;
          border-radius: 4px;
        }
      }

      .consult_ctns {
        img, br {
          display: none;
        }

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: rgba(136, 136, 136, 1);
        line-height: 18px;

        p, span, ol, li, ul, h1, h2, strong, em, h3, a, pre {
          display: inline;
          color: rgba(136, 136, 136, 1) !important;
          background: none !important;
        }
      }

      .botton_text {
        margin-top: 4px;

        >div {
          display: flex;
          align-items: center;
        }

        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(202, 202, 210, 1);
        line-height: 16px;

        img {
          width: 16px;
        }
      }

      .container_ctn {
        margin-right: 16px;
        width: 76%;
      }
    }
  }

  .nomore {
    font-size: 13px;
    padding-bottom: 10px;
    text-align: center;
    color: rgba(202, 202, 210, 1);
    line-height: 40px;
  }
}
</style>